import React from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';

const PrivacyPolicy = () => {

  return (
    <>
      <Header />
      
<main className="min-h-screen bg-gray-50 default-section">
      {/* Top Section */}
      <div className="max-w-4xl mx-auto">
        <div className="relative w-full bg-slate-50 py-10 md:py-10">
          <div className="bg-white rounded-lg shadow-sm p-8">
          {/* Heading */}
          <h1 className="text-4xl font-bold text-gray-900 mb-8">TERMS OF USE</h1>
          
          {/* Ordered List of Terms */}
          <ol className="list-decimal list-inside mb-4">
            <li className="mb-2">
              Please read these terms of use (these "Terms of Use" & “Disclaimer”) carefully. By accessing or using the https://www.connectingtraveller.com/ domain, any subdomain of this website (the "Website"), and other services hosted by or on behalf of connectingtraveller or its affiliated companies (including without limitation the Website, the "Services"), you agree that you have read, understand and agree to comply with and be bound by these Terms and Conditions, whether or not you are a registered member of the Website or other Services. Please also read our Privacy Policy, and Disclaimer carefully to understand what we do with the personal information that we collect as part of your interaction with the Services. These Terms and Conditions, including without limitation the Terms of Use, Privacy Policy, and Disclaimer, govern your use of the Services and constitute a legal contract between you and connectingtraveller ("Company” or," "we" or "us").
            </li>
            <li className="mb-2">
              This document is an electronic record in terms of The Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
            </li>
            <li className="mb-2">
              This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, Privacy Policy and Terms of Use for access or usage of connectingtraveller Website https://www.connectingtraveller.com.
            </li>
            <li className="mb-2">
              The domain name https://www.connectingtraveller.com ("Website"), is owned and operated by HODOPHILE CONNECTING TRAVELLER PRIVATE LIMITED having its registered office at B9, SH1, Shalimar Garden, Ghaziabad, Uttar Pradesh - 201005.
            </li>
            <li className="mb-2">
              Connectingtraveller (“Our”, “Us”, “We”, “Website”, “Site”) is a community, networking, and platform connecting customers/users with travellers and travel consultants.
            </li>
            <li className="mb-2">
              The expressions “You”, “Your” or “User” shall mean any natural or legal person who creates an account on this Website or avails Our Services through this Website.
            </li>
            <li className="mb-2">
              By accessing and/or using the website, you agree to these Terms of Use. If you do not agree, please do not use the website.
            </li>
            <li className="mb-2">
              We reserve the right to change or modify these Terms at any time without prior notice. Continued use after changes indicates acceptance.
            </li>
          </ol>

          {/* Restrictions Section */}
          <h3 className="text-lg font-semibold mb-2">Restrictions; Use of Services</h3>
          <ol className="list-upper-roman list-inside mb-4">
            <li className="mb-2">
              The following restrictions apply to your use of the Services:
              <ol className="list-alpha list-inside ml-4 mt-2">
                <li className="mb-2">You will not engage in activities that violate applicable laws or regulations.</li>
                <li className="mb-2">You will not commercially exploit any part of the Services except as permitted by the Company.</li>
                <li className="mb-2">All content is owned and controlled by the Company unless otherwise indicated. You may not use, modify, or reproduce content without permission.</li>
                <li className="mb-2">You may not interfere with security features or restrict use of the Content.</li>
                <li className="mb-2">Unauthorized use, misuse, or violation of these Terms is prohibited.</li>
                <li className="mb-2">You must create an account to use the website and not attempt unauthorized access.</li>
                <li className="mb-2">You are prohibited from posting spam, viruses, impersonating others, inciting illegal activities, or violating laws.</li>
                <li className="mb-2">You may not assign or transfer your account.</li>
                <li className="mb-2">Using the Service for unlawful purposes or causing nuisance is forbidden.</li>
                <li className="mb-2">Reverse engineering, automated programs, harm to the site, or copying ideas is prohibited.</li>
              </ol>
            </li>
            <li className="mb-2">You are responsible for any breach of your obligations and the consequences thereof.</li>
            <li className="mb-2">Connecting Traveller may block users spreading misinformation, inappropriate content, fake profiles, spam, or fraud. Appeals can be sent to support@connectingtraveller.com.</li>
            <li className="mb-2">If a Local Expert cannot fulfill a stay or itinerary, they must inform the traveler; otherwise, membership may be canceled.</li>
            <li className="mb-2">Connecting Traveller cannot assist with visas or travel expenses. Users should verify visa requirements before traveling.</li>
            <li className="mb-2">Membership may be canceled without refund if terms are violated or misuse occurs.</li>
            <li className="mb-2">We are not responsible for damages or harms from interactions with other users. Personal insurance is recommended.</li>
          </ol>

          {/* Content & IP */}
          <h3 className="text-lg font-semibold mb-2">Content and Intellectual Property</h3>
          <ol className="list-upper-roman list-inside mb-4">
            <li className="mb-2">
              Content provided by the Company and licensors remains the property of the Company. You need written permission to use content.
            </li>
            <li className="mb-2">Unauthorized use of content is prohibited and may violate laws.</li>
            <li className="mb-2">Trademarks like Connecting Traveller™ are proprietary.</li>
            <li className="mb-2">Design elements are trademarks or trade dress of the Company.</li>
            <li className="mb-2">Third-party user content is used for informational purposes only; the Company is not liable.</li>
            <li className="mb-2">The Company owns or licenses all content on the site.</li>
            <li className="mb-2">For infringement concerns, contact: support@connectingtraveller.com with details.</li>
          </ol>

          {/* Pricing */}
          <h3 className="text-lg font-semibold mb-2">Pricing</h3>
          <p className="mb-4">Prices at the time of order will be charged on the delivery date.</p>

          {/* Suggestions & Feedback */}
          <h3 className="text-lg font-semibold mb-2">Suggestions and Feedback</h3>
          <p className="mb-4">
            Suggestions are deemed confidential, and the Company may use them freely without compensation.
          </p>

          {/* Third-Party Sites */}
          <h3 className="text-lg font-semibold mb-2">Third-Party Sites</h3>
          <p className="mb-4">
            The Terms only apply to our Services; we are not responsible for external sites or content.
            Social media content is subject to platform policies; we have no control over these.
          </p>

          {/* Termination */}
          <h3 className="text-lg font-semibold mb-2">Termination</h3>
          <p className="mb-4">
            The Company may suspend or terminate access at any time without notice, for reasons including misconduct or security issues.
          </p>

          {/* Miscellaneous */}
          <h3 className="text-lg font-semibold mb-2">Miscellaneous</h3>
          <ol className="list-upper-roman list-inside mb-4">
            <li className="mb-2">Invalid provisions are severable; remaining terms stay effective.</li>
            <li className="mb-2">This document is the entire agreement.</li>
            <li className="mb-2">No waiver of rights unless in writing.</li>
            <li className="mb-2">Claims must be filed within 6 months.</li>
            <li className="mb-2">Users must provide accurate info; misrepresentation can lead to cancellation.</li>
            <li className="mb-2">Company can cancel orders if info is suspicious or unauthorized.</li>
            <li className="mb-2">Users indemnify the Company against liabilities arising from misuse.</li>
          </ol>

          {/* Disclaimer */}
          <h3 className="text-xl font-bold underline mb-4 mt-8">DISCLAIMER</h3>
          <ol className="list-upper-alpha mb-4 ml-4">
            <li className="mb-2">Services are provided “as is” without warranties. Use at your own risk.</li>
            <li className="mb-2">Services may be temporarily unavailable; the Company is not liable for errors or damages.</li>
            <li className="mb-2">No warranties are given; damages are limited.</li>
            <li className="mb-2">Liability is limited to fees paid.</li>
            <li className="mb-2">Invalid or unenforceable provisions are severed.</li>
          </ol>

          {/* Liability & Release */}
          <h3 className="text-xl font-bold underline mb-4 mt-8">Liability & Release</h3>
          <ol className="list-upper-alpha mb-4 ml-4">
            <li className="mb-2">We are not liable for damages from use or inability to use the Service.</li>
            <li className="mb-2">Connecting Traveller is a platform; users cannot hold us liable for damages caused by interactions.</li>
            <li className="mb-2">You release claims against the Company for liabilities arising from use.</li>
          </ol>

          {/* Indemnification */}
          <h3 className="text-lg font-semibold mb-2">Indemnification</h3>
          <p className="mb-4">
            Users agree to defend and indemnify the Company against claims arising from misuse or violations.
          </p>

          {/* Disputes & Governing Law */}
          <h3 className="text-lg font-semibold mb-2">Disputes & Governing Law</h3>
          <p className="mb-4">
            Disputes are subject to arbitration in Ghaziabad, UP under Indian law. The courts of Ghaziabad have exclusive jurisdiction.
          </p>

          {/* Your Rights */}
          <h3 className="text-lg font-semibold mb-2">Your Rights</h3>
          <p className="mb-4">
            You can request access, correction, or deletion of your personal data by contacting: <a className="text-blue-600 underline" href="mailto:info@connectingtraveller.com">info@connectingtraveller.com</a>.
          </p>
          </div>
        </div>
      </div>
    </main>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
